package csaware.utilities

import kafffe.core.KafffeComponentWithModel
import kafffe.core.KafffeHtml
import kafffe.core.KafffeHtmlBase
import kafffe.core.Model
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.KeyboardEvent
import kotlinx.browser.window
import kotlin.math.max
import kotlin.math.min

/*
 * A table column header for applying filtering to a table. The filtering is done by the using code, this only updates a model.
 * This supports the selection of multiple values.
 */
class ColumnHeaderMultipleDropdownFilter(
    private val headerLabelModel: Model<String>,
    model: Model<List<String>>,
    private val choiceModel: Model<List<String>>
) : KafffeComponentWithModel<List<String>>(model) {
    private var dropdownElement: HTMLDivElement? = null
    private var choicesContainer: HTMLDivElement? = null
    private var filterInput: HTMLInputElement? = null

    private var selIndex = -1


    private fun keydownHandling(it: KeyboardEvent) {
        when (it.key) {
            "Escape" -> model.data = model.data
            "Enter" -> toggleChoice(filteredChoices()[selIndex])
            "ArrowDown" -> selectNext()
            "ArrowUp" -> selectPrev()
        }
        it.stopPropagation()
    }

    private fun openDropdown() {
        dropdownElement?.style?.display = "block"
        filterInput?.focus()
    }

    private fun closeDropdown() {
        dropdownElement?.style?.display = "none"
    }

    override fun KafffeHtmlBase.kafffeHtml() =
        div {
            selIndex = choiceModel.data.indexOf(model.data.firstOrNull() ?: "")
            withElement {
                style.position = "relative"
                style.cursor = "pointer"
                tabIndex = 0
                onfocus = { openDropdown() }
                onclick = {
                    openDropdown()
                    it.stopPropagation()
                }
                if (model.data.isNotEmpty()) {
                    title = model.data.joinToString(", ")
                }
            }
            span {
                text(headerLabelModel.data)
            }
            i {
                addClass("fas fa-filter")
                addClass(if (model.data.isEmpty()) "text-secondary" else "text-warning")
                 element.style.cssFloat = "right"
            }
            dropdownElement = div {
                addClass("sd_dropdown bg-info")
                withElement {
                    style.display = "none"
                    style.minWidth = "16rem"
                }
                div {
                    addClass("sd_dropdown_item")
                    filterInput = input {
                        addClass("form-control")
                        withElement {
                            type = "text"
                            value = choiceFilter
                            oninput = {
                                choiceFilter = value
                                dropDownChildren()
                            }
                            onblur = { window.setTimeout(closeDropdown(), 100) }
                            onkeydown = ::keydownHandling
                            onclick = {
                                focus()
                                it.stopPropagation()
                            }
                        }
                    }.element
                }
                choicesContainer = div().element
            }.element
            dropDownChildren()
        }

    private var choiceFilter = ""

    private fun dropDownChildren() {
        choicesContainer?.let { choicesContainer ->
            choicesContainer.innerHTML = ""
            val kafffeDrop = KafffeHtml(choicesContainer)
            val choices = model.data + (filteredChoices().filter { choice -> choice !in model.data })
            selIndex  = min(selIndex, choices.size - 1)
            kafffeDrop.div {
                choices.forEachIndexed { index, choice ->
                    div {
                        addClass("sd_dropdown_item")
                        if (selIndex == index)  {
                            addClass("sd_current")
                            i {
                                addClass("fa-solid fa-chevron-right me-1")
                            }
                        }
                        if (choice in model.data) {
                            addClass("sd_selected")
                            i {
                                addClass("fa-solid fa-check me-2")
                            }
                        }
                        text(choice)
                        element.onclick = {
                            toggleChoice(choice)
                            it
                        }
                    }
                }
            }
        }
    }

    private fun toggleChoice(choice: String) {
        if (choice in model.data) {
            model.data = model.data - choice
        } else {
            model.data = model.data + choice
        }
    }

    private fun filteredChoices() =
        choiceModel.data.filter { choice -> choiceFilter.isBlank() || choice.startsWith(choiceFilter, true) }

    private fun selectNext() {
        selIndex = min(choiceModel.data.size - 1, selIndex + 1)
        updateSelection()
    }

    private fun selectPrev() {
        selIndex = max(0, selIndex - 1)
        updateSelection()
    }

    private fun updateSelection() {
        // could be optimized to only move "sd_selected" class
        dropDownChildren()
    }

}